import { render, staticRenderFns } from "./block-profile-menu.vue?vue&type=template&id=065894fa&scoped=true&lang=pug"
import script from "./block-profile-menu.vue?vue&type=script&lang=js"
export * from "./block-profile-menu.vue?vue&type=script&lang=js"
import style0 from "./block-profile-menu.vue?vue&type=style&index=0&id=065894fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065894fa",
  null
  
)

export default component.exports